import type GetAllOrdersDTO from '../repositories/order/dto/getAll.dto'
import type OrderModel from '../models/order.model'
import { type CreateOrderDTO, UpdateOrderDTO } from '../index'
import type OrdersController from '../controllers/orders/orders.controller'
import { OrderApiWs, type OrderWSUpdate } from "@trading/infrastructure";

export default class OrderService {

  constructor(
    private ordersRepo: OrdersController,
    private repo: OrderApiWs
  ) {
  }

  async getAllOrders(dto: GetAllOrdersDTO): Promise<OrderModel[]> {
    return await this.ordersRepo.getAllOrders(dto)
  }

  async subscribeToOrdersUpdate(
    cb: (order: OrderWSUpdate) => void
  ): Promise<undefined | CallableFunction> {
    return await this.repo.subscribeToChannelsAction('update', cb)
  }

  unsubscribe(): void {
    this.repo.unsubscribeToChannel()
  }

  async subscribeToOrdersSnapshot(
    cb: (order: OrderWSUpdate) => void
  ): Promise<undefined | CallableFunction> {
    return await this.repo.subscribeToChannelsAction('snapshot', cb)
  }

  // initTable(dto: GetAllOrdersDTO) {
  //   // this.getAllOrders(dto)
  // }

  async updateOrder(dto: UpdateOrderDTO, id: number) {
    return await this.ordersRepo.updateOrder(dto, id)
  }

  async createOrder(dto: CreateOrderDTO): Promise<OrderModel> {
    return await this.ordersRepo.createOrder(dto)
  }

  async closeOrder(id: ID) {
    return await this.ordersRepo.closeOrder(id)
  }

  async cancelOrdersBySymbol(symbol: string): Promise<number> {
    return await this.ordersRepo.cancelOrdersBySymbol(symbol)
  }
}
